module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"currencyComboBox.currency":"Currency","currencyComboBox.fallbackPlaceholder":"Please enter the currency code of your choosing e.g. AUD"}}')
  delete Component.options._Ctor
}
